<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte'; // Import onMount
    import { fetchEmpresas, saveEmpresa, removeEmpresa, searchEmpresas, subscribeToEmpresas, unsubscribeFromEmpresas } from '../controllers/empresaController.js';
    import { fetchMonedas } from '../controllers/monedaController.js'; // Function to fetch monedas

    let empresaColumns = [
        { label: 'Nombre Comercial', field: 'nombre_comercial', type: 'text' },
        { label: 'Razón Social', field: 'razon_social', type: 'text'},
        { label: 'Teléfono', field: 'telefono', type: 'text' },
        { label: 'NIT', field: 'nit', type: 'text' },
        { label: 'Email', field: 'email', type: 'text' },
        { label: 'Porcentaje IVA', field: 'porc_iva', type: 'number' },
        { label: 'Estado', field: 'sta', type: 'bool' },
        { label: 'Fecha Inicio Periodo', field: 'fecha_inicio_periodo', type: 'date' },
        { label: 'Fecha Fin Periodo', field: 'fecha_fin_periodo', type: 'date' },
        { label: 'Logo', field: 'logo', type: 'image'}
    ];

    let newEmpresa = {
        nombre_comercial: '',
        razon_social: '',
        direccion: '',
        departamento: '',
        municipio: '',
        codigo_postal: '',
        telefono: '',
        nit: '',
        email: '',
        porc_iva: 0,
        sta: true,
        default: false,
        logo: null, // Para manejar la carga del archivo de logo
    };

    let editColumns = [
        { label: 'Nombre Comercial', key: 'nombre_comercial', type: 'text', required: true },
        { label: 'Razón Social', key: 'razon_social', type: 'text', required: true },
        { label: 'Dirección', key: 'direccion', type: 'text', required: true },
        { label: 'Departamento', key: 'departamento', type: 'text', required: true },
        { label: 'Municipio', key: 'municipio', type: 'text', required: true },
        { label: 'Código Postal', key: 'codigo_postal', type: 'text', required: true },
        { label: 'Teléfono', key: 'telefono', type: 'text', required: true },
        { label: 'NIT', key: 'nit', type: 'text', required: true },
        { label: 'Email', key: 'email', type: 'email', required: true },
        { label: 'Porcentaje IVA', key: 'porc_iva', type: 'number', step: '0.01', required: true },
        { label: 'Fecha Inicio Periodo', key: 'fecha_inicio_periodo', type: 'date', required: true },
        { label: 'Fecha Fin Periodo', key: 'fecha_fin_periodo', type: 'date', required: true },
        { label: 'Fecha Inicio Trabajo', key: 'fecha_inicio_trabajo', type: 'date', required: true },
        { label: 'Fecha Fin Trabajo', key: 'fecha_fin_trabajo', type: 'date', required: true },
        { label: 'Moneda', key: 'moneda', type: 'json', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: 'Estado', key: 'sta', type: 'checkbox' },
        { label: 'Logo', key: 'logo', type: 'file', required: false },
    ];

    let monedaOptions = []; // Array to hold transformed moneda options

    // Function to fetch and transform monedas
    async function loadMonedas() {
        try {
            const fetchedMonedas = await fetchMonedas(); // Fetch monedas from the backend

            // Check if fetchedMonedas is an array
            if (Array.isArray(fetchedMonedas.moneda)) {
                // Transform the fetched data based on the fetchOptions
                monedaOptions = fetchedMonedas.moneda.map(m => ({
                    key: m[editColumns.find(col => col.key === 'moneda').fetchOptions.key],
                    value: m[editColumns.find(col => col.key === 'moneda').fetchOptions.value],
                }));

                // Assign the transformed options to the editColumns
                editColumns.find(column => column.key === 'moneda').options = monedaOptions;
            } else {
                console.error('Expected an array of monedas, but got:', fetchedMonedas);
            }
        } catch (error) {
            console.error('Error fetching monedas:', error);
        }
    }


    // Load monedas on component mount
    onMount(() => {
        loadMonedas();
    });
</script>

<CRUD 
    title="Empresas"
    entityName="empresa"
    newEntity={newEmpresa}
    columns={empresaColumns}
    fetchEntities={fetchEmpresas}
    saveEntity={saveEmpresa}
    removeEntity={removeEmpresa}
    searchEntities={searchEmpresas}
    subscribeToChanges={subscribeToEmpresas}
    unsubscribeFromChanges={unsubscribeFromEmpresas}
    editColumns={editColumns}
/>
